// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Mc2_","importantInfo":"styles_importantInfo__3iQrj"};